import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { StudentDetails } from '../../loan-gtm-interface/loan-gtm.interface';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
declare let gtag: Function;
@Component({
  selector: 'fa-loan-basic-information',
  templateUrl: './loan-basic-information.component.html',
  styleUrls: ['./loan-basic-information.component.scss']
})
export class LoanBasicInformationComponent implements OnInit {
  model: any = {};
  dataModel: string = "users";
  isPartnerLink: boolean = false;
  partnerLogo: string;
  targetIntakeOptions = this.configService.getConfig1("foreignAdmits", "targetIntakeOptions");
  targetCountryOptions = this.configService.getConfig1("foreignAssist", "countryOptions");
  targetDegreeOptions = this.configService.getConfig1("foreignAssist", "degreeOptions");
  loanWidgetConfig = this.configService.getConfig1("loanWidgetConfig")
  currentCountry: string;
  layout: FormlyFieldConfig[];
  userData: {};
  orientation: String;
  canLogout: boolean = true;

  configBasicInformationHeader: HeaderInterface = {
    title: "Tell us about your Study Abroad plans",
    back: {
      link: 'personal-details/',
      step: 'secondStep'
    }
  }

  steps: any = this.loanWidgetConfig?.basicDetailsStepperConfig

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData);
  }

  trackEvent(event, data = {}) {
    mixpanel.track(event, data);
  }

  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
    private userIdentity: UserIdentityService,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid && (puid == 'LGQUJ0E2' || puid == 'LFI75BEH') && !this.loanService.isPrefilledDataOnBack) {
      let mobile = this.loanService.studentDetails.mobile;
      mobile = (this.loanService.studentDetails.mobile).replace("+91", "")
      this.apiHelper.getData(`client/get-outbound-data/${mobile}`).then((data: any) => {
        if (data?.permanentPincode) {
          this.loanService.getLocation(data?.permanentPincode).then((data) => {
            this.model.address = { ...data[0] };
          });
        }
        if (data?.currentPincode) {
          this.loanService.getLocation(data?.currentPincode).then((data) => {
            this.model.currentAddress = { ...data[0] };
          });
        }
        this.prepareUpdatedData(data);
        this.loanService.isPrefilledDataOnBack = true;
      })
      this.apiHelper.getData(`client/get-outbound-documents/${mobile}`).then((data: any) => {
        return data;
      })
    }
    if (puid) {
      
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }
    }
    if (this.activatedRoute.snapshot.queryParams?.hasOwnProperty("referenceId") && this.activatedRoute?.snapshot.queryParams.hasOwnProperty("token")) {
      const referenceId = this.activatedRoute?.snapshot?.queryParams?.referenceId;
      const token = this.activatedRoute?.snapshot?.queryParams?.token
      this.loanService.getStudentDetailsById(referenceId).then((data: any) => {
        const userDetails = { ...data[0] }
        this.loanService.saveStudentDetails(data[0]);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        localStorage.setItem("token", token);
        localStorage.setItem("userId", referenceId);
        localStorage.setItem("ttl", "3600");
        this.canLogout = false;
        sessionStorage.setItem("canLogout", "false")
        this.getPartnerDetails(data[0]?.puid);
        this.dataPreprocessor();
      })
    }
    this.canLogout = sessionStorage.getItem("canLogout") ? JSON.parse(sessionStorage.getItem("canLogout")) : true
    this.dataPreprocessor();
    this.checkUserLoggedIn();
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
    }
    else if (!this.userIdentity.isValidToken()) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/']);
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
    }
    this.dataPreprocessor();
  }

  prepareUpdatedData(data: any) {
    let updateData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      targetDegree: data?.targetDegree,
      targetCountry: data?.targetCountry,
      targetIntake: data?.targetIntake,
      currentAddress: {
        pincode: data?.currentPincode
      },
      address: {
        city: data?.city,
        state: data?.state,
        country: data?.country,
        pincode: data?.permanentPincode,
      },
      academicDetails: {
        course: data?.targetCourse,
        university: data?.targetUniversity,
        courseType: data?.courseType
      }
    } as StudentDetails;

    this.loanService.saveStudentDetails(updateData);

    this.dataPreprocessor();
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid)?.subscribe({
      next: (response: any) => {
        // Handle successful response
        let partnerDetails = { ...response };
        localStorage.setItem('puid', partnerUid);
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
        this.layout = undefined;
        let newModel = { ...this.model };
        this.model = undefined;
        this.model = { ...newModel }
        this.setLayout();
      },
      error: (error: any) => {
        this.route.navigate(['/basic-information'])
        this.isPartnerLink = false;
      }
    });

  }

  dataPreprocessor() {

    this.model = { ...this.loanService.studentDetails };
    if (this.model?.address?.id) {
      delete this.model?.address?.id
    }
    if (this.model?.targetCountry) {
      this.currentCountry = this.model?.targetCountry;
    }

    if (!this.loanService?.isMobileIndian(this.loanService?.studentDetails?.mobile)) {
      this.targetDegreeOptions = this.targetDegreeOptions.filter((single) => single?.value != 'Bachelors')
    }
    this.steps.steps[1].status="progress"
    this.steps.steps[2].status="progress"
    this.setLayout();
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row text-secondary align-items-center padding-custom style-left",
        fieldGroup: [
          {
            className: "col-12",
            key: "targetCountry",
            type: "select",
            templateOptions: {
              required: true,
              label: "Country you are planning to go?",
              options: this.targetCountryOptions,
              placeholder: "Select your Target Country"
            }
          },

          {
            className: "col-12",
            key: "targetIntake",
            type: "select",
            templateOptions: {
              required: true,
              label: "Which session/intake?",
              options: this.targetIntakeOptions,
              placeholder: "Select your Target Intake"
            }
          },

          {
            className: "col-12",
            key: "targetDegree",
            type: "radio",
            templateOptions: {
              required: true,
              label: "Which Degree?",
              options: this.targetDegreeOptions,
              placeholder: "Select your Target Degree"
            }
          },

          {
            className: "col-12",
            type: "button",
            templateOptions: {
              btnType: "primary w-100 gradient py-3",
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.targetCountry === undefined || this.model?.targetIntake === undefined || this.model?.targetDegree === undefined) {
                  this.model["error"] = "Hello world"
                }
                else {
                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                    }
                    if (this.loanService.partnerDetails) {
                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
                    }
                    this.trackEvent("Next Button of Basic Details on Loan Widget  Clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if ([undefined, ""," "].includes(this.model?.targetCountry) || [undefined, ""," "].includes(this.model?.targetIntake) || [undefined, ""," "].includes(this.model?.targetDegree)) {
                  return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                }
                else {
                  return "primary w-100 py-3 fw-bold rounded-custom "
                }
              }
            }
          }
        ]
      }
    ]
  }

  dataProcessor(data: any) {
    if (data?.error) {
      delete data?.error
      this.model.error = undefined;
    }
    if (data?.address?.id) {
      delete data?.address?.id
    }
    if (data?.currentAddress?.id) {
      delete data?.currentAddress?.id
    }

    if (data?.academicDetails?.languageExam) {
      delete data?.academicDetails?.languageExam;
    }

    if (data?.academicDetails?.aptitudeExam) {
      delete data?.academicDetails?.aptitudeExam
    }
    return data;
  }

  onSubmit(event: any) {
    if (!event?.error) {
      if (this.currentCountry && event?.data?.targetCountry != this.currentCountry) {
        if (event?.data?.academicDetails) {
          event.data.academicDetails.university = "";
        }
      }
      this.loanService.saveStudentDetails(event?.data, true).then(() => {
        if (this.isPartnerLink) {
          this.route.navigate(['academic-details/' + this.loanService?.partnerDetails?.uid]);
          return;
        }
        this.route.navigate(['academic-details'])

      })

      gtag('event', 'basic_information_submit', {
        'event_category': 'button',
        'event_label': 'Basic information submit button',
        'value': "Basic information"  
      });

      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.model?.mobile
      })
    }
  }

  back() {
    if (this.loanService.partnerDetails) {
      this.route.navigate([this.loanService.partnerDetails?.uid]);
      return;
    }
    this.route.navigate([''])
  }

  emitStep(ev: any) {
    sessionStorage.setItem("stepHeading",ev.step)
    this.steps.steps[1].status="progress"
    this.steps.steps[2].status="progress"
    if (this.isPartnerLink) {
      this.route.navigate([ev.link + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate([ev.link])
  }
}
